var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('b-alert',{attrs:{"show":"","variant":"secondary"}},[_c('h5',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.message))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }